import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ConfigState {
  strongCompressionLocked: boolean;
  // Add other config properties here as needed
  darkMode: boolean;
}

const initialState: ConfigState = {
  strongCompressionLocked: false,
  darkMode: false,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setStrongCompressionLocked: (state, action: PayloadAction<boolean>) => {
      state.strongCompressionLocked = action.payload;
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },

    // Add more configuration setters as needed
  },
});

export const { setStrongCompressionLocked, setDarkMode } = configSlice.actions;
export default configSlice.reducer;
